import { dateFilterSpec } from '@ow/utils'

export { dateFilterSpec as filterSpec }

export const config = {
  type: 'datetime',
  // 通用：控件的标题, 显示在题设部分, 要求不超过 250 字
  title: '日期',

  render: 'picker',

  // 通用：字段本身的说明文字，不是设置项
  intro: '请选择日期',

  // 通用：通过 title 由拼音和唯一性随机串生成
  slug: `datetime${Math.round(Math.random() * 100)}`,

  // 独有：起始日期
  startDate: '',

  // 独有：结束日期
  endDate: '',

  // 独有：时间格式
  timeformate: ['年月', '年月日', '年月日时分', '年月日时分秒'],
}
